import React, {Component} from 'react';
import './SpinnerNumbers.css';
import gif from './../../../img/Infinity-1s-200px.svg'

export default class SpinnerNumbers extends Component {
    render() {
        return (
            <div className={"SpinnerNumbers"}>
                <img src={gif} alt=""/>
            </div>

        );
    }
}


